import { Component, Element, h, Prop, Watch } from '@stencil/core';
import { Provider } from '@sydle/ui-utils';

/**
 * @slot - Elements that can consume the context.
 */
@Component({
  tag: 'sy-context-provider',
  shadow: true,
})
export class ContextProvider {
  private provider: Provider;

  @Element() el: HTMLSyContextProviderElement;

  /**
   * Context identifier
   */
  @Prop({ reflect: true }) context: string;

  /**
   * Context value
   */
  @Prop() value: any;

  @Watch('value')
  valueWatcher(): void {
    this.provider.update(this.context, this.value);
  }

  connectedCallback() {
    this.provider = new Provider(this.el);
    this.provider.provides(this.context, this.value);
  }

  disconnectedCallback() {
    this.provider.disconnect();
  }

  render() {
    return <slot />;
  }
}
